import {
    GET_CREDIT_LIMIT_MODEL_SUCCESS,
} from '../View/action';
const initialState = {
    creditLimitModelListSuccess: [],
}

const creditLimitModelListReducer = (state=initialState, action) => {
    switch(action.type) {
        case GET_CREDIT_LIMIT_MODEL_SUCCESS:
            return  state = {
                ...state,
                creditLimitModelListSuccess: action.data
            }
        default: return state
    }
}
export default creditLimitModelListReducer;
